<template>
  <div class="flex items-center border rounded-lg py-2 mt-4">
    <img class="w-16" :src="item.product.photo.path" alt=""
         @error="$event.target.src = require('@/assets/img/food_placeholder.png')">

    <div class="mr-2">
      <h1 class="text-sm">{{ item.product.name }}</h1>
      <h3 class="text-xs mt-1 text-gray-500">
        قیمت:
        <span class="text-green-500">
          <span>{{ $helper.priceFormatter(item.price, false) }}</span>
        </span>
        تومان
      </h3>
      <h3 class="text-xs mt-1 text-gray-500">
        وضعیت:
        <span :class="statusClass(item.status)">{{ status(item.status)}}</span>
      </h3>
      <h3 class="text-xs mt-1 text-gray-500" v-if="item.status === 'rejected'">علت رد: {{ item.deny_reason }}</h3>
    </div>

<!--    <div class="text-xs mx-auto rounded-md p-1" :class="statusClass(item.status)">{{ status(item.status) }}</div>-->

    <div class="flex items-center text-xs ml-4 mr-auto">
      <span>تعداد</span>
      <div class="bg-brand py-1 px-2 rounded-lg text-sm mr-2">
        <span>{{ item.count }}</span>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "OrderProductCard",
  props: ['item'],
  methods: {
    statusClass(status) {
      switch (status) {
        case 'pending':
          return 'text-yellow-500'
        case 'seen':
          return 'text-purple-500'
        case 'delivered':
          return 'text-green-500'
        case 'rejected':
          return 'text-red-500'
      }
    },
    status(status) {
      switch (status) {
        case 'pending':
          return 'در انتظار'
        case 'seen':
          return 'دیده شده'
        case 'delivered':
          return 'تحویل شده'
        case 'rejected':
          return 'رد شده'
      }
    },
  }
}
</script>

<style scoped>

</style>